import React from "react";
import "./Book3.css";

const BookNowsec3 = () => {
  return (
    <>
      <div className="container-fluid main-book3">
        <div className="container main3">
          <div className="row contn">
            <div className="col-lg-4 col-md-12 ">
              <h4 className="hdng">Contact Info</h4>
              <div className="pra d-flex">
                <p className="pra-heading">
                  <b>Address:</b>
                </p>
                <p className="ms-3">
                  Lorem ipsum dolor sit amet Adipiscing Lorem ipsum dolor sit
                  amet Adipiscing
                </p>
              </div>
              <div className="pra d-flex">
                <p className="pra-heading">
                  <b>Phone:</b>
                </p>
                <p className="ms-3">9876543218</p>
              </div>
              <div className="pra d-flex">
                <p className="pra-heading">
                  <b>Email: </b>
                </p>
                <p className="ms-3"> suryavilaspalace@gmail.com</p>
              </div>
              <h4 className="hdng">Get Social</h4>
              <div className="d-flex gap-4">
                <img className="icons" src="./Group 48098358.png" alt="#" />
                <img className="icons" src="./Group 48098362.png" alt="#" />
                <img className="icons" src="./Group 48098361.png" alt="#" />
              </div>
            </div>
            {/* <div className="col-1 se"></div> */}
            <div className="col-lg-8 col-md-12  map">
              <iframe
                title="myFrame"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3548.914062982393!2d77.52795367403066!3d27.190437648102975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3973a31edd4ceb17%3A0xc04e856742906bc3!2sHotel%20Surya%20Vilas%20palace!5e0!3m2!1sen!2sin!4v1721980391030!5m2!1sen!2sin"
                className="iframe"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNowsec3;
